// @flow

/**
 * Asynchronously loads the component for Plan Eligible Patients
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});
